import React from 'react';
import {RootState} from 'app/rootReducer';
import {RouteComponentProps} from 'react-router';
import {imagesRoute, ImagesRoute} from 'app/appRoutes';
import {push} from "connected-react-router";
import {saveImageData, saveImageReplacement} from '../imageListSlice';
import {connect, ConnectedProps} from 'react-redux';
import ImageModal from './ImageModal';
import {SaveImageDataDto} from 'interfaces/dto';

type Props = ConnectedProps<typeof connector>;

class HwImageModalContainer extends React.Component<Props> {
    getImage() {
        const {match: {params}, images} = this.props;
        const imageIdx = params.imageIdx ? parseInt(params.imageIdx) : NaN;
        if (isNaN(imageIdx) || !images || images.length < imageIdx + 1) {
            return null;
        }
        return images[imageIdx];
    }
    
    render() {
        const {match: {params}, push, images, pageCount, isLoading, isUploadingImageReplacement, saveImageData, saveImageReplacement} = this.props;
        const image = this.getImage();

        const closeModal = () => {
            push(imagesRoute(params.filterId, params.reviewedAfter, params.page));
        };

        const navigateToNextImage = () => {
            let idx = +(params.imageIdx || 0);
            let page = +params.page;
            if (idx < images.length - 1) {
                idx++;
            } else {
                if (page < pageCount) {
                    page++;
                    idx = 0;
                } else {
                    return closeModal();
                }
            }
            push(imagesRoute(params.filterId, params.reviewedAfter, page, idx));
            document.getElementsByClassName("modal")[0].scrollTop = 0; //AG quick hotfix, probably there is a better way
        };

        const handleSave = (next: boolean, dto: SaveImageDataDto) => {
            saveImageData(dto);
            next ? navigateToNextImage() : closeModal();
        }
        
        return !!image && <ImageModal isLoading={isLoading} 
                                            image={image}
                                            closeModal={closeModal} 
                                            navigateToNextImage={navigateToNextImage}
                                            handleSave={handleSave} isUploadingFiles={isUploadingImageReplacement}
                                            handleUploadReplacement={saveImageReplacement}    />;
    }
}

const mapStateToProps = (state: RootState, ownProps: RouteComponentProps<ImagesRoute>) => {
    return {
        ...state.imageList,
        isLoading: state.api.isLoading,
        isUploadingImageReplacement: state.api.loadingProcList.indexOf('uploadImageReplacement') > -1,
        ...ownProps
    }
};
const mapDispatchToProps = {push, saveImageData, saveImageReplacement};
const connector = connect(mapStateToProps, mapDispatchToProps);
export default connector(HwImageModalContainer);